// Angular
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

// OLCI
import {select, Store} from '@ngrx/store';
import * as fromRoot from '../../../reducers';
import * as fromAnalytics from '../../../reducers/analytics.reducer';
import { constants } from '../../../constants';

import {TealiumService} from '../services/tealium.service';
import {TelemetryGenericEnum} from '../../../shared/enums';
import {
  TrackClearTelemetryErrorAction,
  TrackInlineAlertEventAction,
  TrackPageErrorEventAction
} from '../../../actions/tracking';
import {take} from 'rxjs/operators';
import {TrackErrorPayload} from '../../../models/action-payloads/tracking-payload';
import { getStatusMessage } from '../../../http-interceptors/http-error-map';
import { HttpErrorResponse } from '@angular/common/http';
import { BookingService } from '../services/booking.service';

@Component({
    selector: 'app-error-wrapper-inner-component',
    templateUrl: 'error-wrapper-inner.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ErrorWrapperInnerComponent {
	@Input() public serverErrors: HttpErrorResponse | any;
	@Input() public bundle: any;
	errorMessage = '';
  brandName: string;

	constructor(
    private readonly store: Store<fromRoot.AppState>,
    private readonly tealiumService: TealiumService,
    private bookingService: BookingService
  ) {
    this.brandName = this.bookingService.getBrand();
  }

  public get errorMessages(): {
    errorMessage: string;
    errorType: string;
  }[] {
    const errors = [];
    for (const serverError of this.serverErrors) {
      const error = this.responseErrorMessages(serverError);
      errors.push(error);
    }

    return errors;
  }

	getErrorsByType(errorType: string): any[] {
		return this.errorMessages.filter(e => e.errorType === errorType);
	}

  private responseErrorMessages(serverError: any): {
    errorMessage: string;
    errorType: string;
  } {
    let errorMessage = '';
    let serverErrorHeader = '';
    let serverErrorSubheader = '';
    let serverErrorMessage = '';

    if (this.bundle) {
      serverErrorHeader = this.bundle['server.error.header'];
      serverErrorSubheader = this.bundle['server.error.subheader'];
      serverErrorMessage = `${serverErrorHeader}. ${serverErrorSubheader}`;
    }

    if (serverError?.status !== constants.HTTP_STATUS_CODE.SUCCESS) {
      errorMessage = getStatusMessage(serverError?.error?.error?.errorCode, this.bundle);
    }

    this.store
      .pipe(
        select(fromRoot.getAnalyticsState),
        take(1)
      )
      .subscribe(data => {
        if (data) {
          this.dispatchBackendErrorInteraction(data);
        } else {
          this.dispatchAnalyticsAlertEvent(serverErrorMessage);
        }
      });

    return {
      errorMessage: errorMessage ? errorMessage : serverErrorMessage,
      errorType: 'warning'
    };
  }

  private dispatchBackendErrorInteraction(data: fromAnalytics.State) {
    const telemetryData: TrackErrorPayload = this.tealiumService.retrieveAnalyticsBackendErrorInteraction(data);

    this.store.dispatch(new TrackPageErrorEventAction(telemetryData));
    this.store.dispatch(new TrackClearTelemetryErrorAction());
  }

  private dispatchAnalyticsAlertEvent(serverErrorMessage: string) {
    const telemetryData = this.tealiumService.retrieveAnalyticsAlertInlineResponse(
      TelemetryGenericEnum.EMPTY_VALUE,
      TelemetryGenericEnum.INLINE_ERROR,
      serverErrorMessage,
      true
    );
    this.store.dispatch(new TrackInlineAlertEventAction(telemetryData));
  }
}
